<template>
  <tr>
    <td colspan="8" class="options">
      <div>
        <div>
          <div class="optionsPanel">
            <div class="optionsPanel__image">
              <img :src="manufacturerImage(model.manufacturer_id)" class="manufacturer_image" :class="{'height-250' : model.manufacturer_id === 5 || model.manufacturer_id === 2}" style="max-width: 300px;" />
            </div>
            <div class="optionsPanel__content optionsPanel__content--borderTop">
              <h5>Total current cost per annum <span class="cost" v-html="makeNumberWithPound(current_costs.total_cost_per_annum.toFixed(2))"></span>
                <br>
                <span class="cost">
                  (<span style="font-size: inherit; font-weight: inherit;" v-html="makeNumberWithPound((current_costs.total_cost_per_annum / 4).toFixed(2))"></span> per quarter)
                </span>
              </h5>
              <p class="small">*Calculated using existing service costs, consumable costs, postage
                recredits, invoice fees and insurance fees
                where applicable based on information provided</p>
            </div>
          </div>
        </div>
        <div>
          <table class="featureTable">
            <thead>
            <th>
              Feature
            </th>
            <th>
              Specification
            </th>
            <th>
              Info and upgrade options
            </th>
            </thead>
            <tbody>
            <tr>
              <td>
                Printing capabilities
              </td>
              <td>
                {{ model.printing_capabilities }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="PRINTING CAPABILITIES">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Programmable jobs
              </td>
              <td>
                {{ model.programmable_jobs }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="PROGRAMMABLE JOBS">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Ink yield
              </td>
              <td>
                {{ model.ink_yield }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="INK YIELD">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Cost per impression
              </td>
              <td>
                {{ model.cost_per_impression }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="COST PER IMPRESSION">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Logo return address capacity
              </td>
              <td>
                {{ model.return_address_capacity }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="LOGO RETURN ADDRESS CAPACITY">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Interface type
              </td>
              <td>
                {{ model.interface_type }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="INTERFACE TYPE">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Mail feeder
              </td>
              <td>
                {{ model.mail_feeder }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="MAIL FEEDER">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Label dispenser
              </td>
              <td>
                {{ model.label_dispenser }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="LABEL DISPENSER">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Web based reporting
              </td>
              <td>
                <img src="./../../../../static/styles/mailkit/img/tick.png"
                     v-if="model.web_based_reporting === 'yes'"/>
                <img src="./../../../../static/styles/mailkit/img/cross.png" v-else/>

              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="WEB BASED REPORTING">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Dimensions
              </td>
              <td>
                {{ model.dimensions }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="DIMENSIONS">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Mail mark compliant
              </td>
              <td>
                <img src="./../../../../static/styles/mailkit/img/tick.png"
                     v-if="model.mail_mark_compliant === 'yes'"/>
                <img src="./../../../../static/styles/mailkit/img/cross.png" v-else/>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="MAIL MARK COMPLIANT">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Installation and training
              </td>
              <td>
                <img src="./../../../../static/styles/mailkit/img/tick.png"
                     v-if="model.engineer_installation_training === 'Included'"/>
                <img src="./../../../../static/styles/mailkit/img/cross.png"
                     v-if="model.engineer_installation_training === null || model.engineer_installation_training === 'Not Included (Available at additional cost)'"/>
                <span v-if="model.engineer_installation_training === 'Not Included (Available at additional cost)'">
                  <br>
                  Available at additional cost &pound;{{ model.engineer_installation_training_sell_price }}
                </span>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="INSTALLATION AND TRAINING">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Scale capacity
              </td>
              <td>
                {{ model.scale_capacity }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="SCALE CAPACITY">
                </div>
              </td>
            </tr>
            <tr>
              <td style="text-transform: uppercase;">
                Custom Logo/Return Address Included with New Machine
              </td>
              <td>
                <img src="./../../../../static/styles/mailkit/img/tick.png"
                     v-if="model.return_address_included_with_machine === 'Included'"/>
                <span v-else>
                  <img src="./../../../../static/styles/mailkit/img/cross.png"/>
                  <br>
                  <span>Available at additional cost - &pound;{{ model.return_address_sell_price }} </span>
                </span>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;"
                     data-ft="CUSTOM LOGO/RETURN ADDRESS INCLUDED WITH NEW MACHINE">
                </div>
              </td>
            </tr>
            <tr>
              <td style="text-transform: uppercase;">
                Business mail advanced
              </td>
              <td>
                <span v-if="!model.business_mail_advanced.includes('included')">
                  <img src="./../../../../static/styles/mailkit/img/cross.png"/>
                </span>
                <span v-if="model.business_mail_advanced.includes('included')">
                  <img src="./../../../../static/styles/mailkit/img/cross.png"/>
                  <br>
                  <span>Available at additional cost - &pound;{{ model.business_mail_advanced_sell_price }} </span>
                </span>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="BUSINESS MAIL ADVANCED">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Connectivity kit options
              </td>
              <td>
                {{ model.connectivity }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="CONNECTIVITY KIT OPTIONS">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Inbound courier parcel tracing
              </td>
              <td>
                <img src="./../../../../static/styles/mailkit/img/tick.png"
                     v-if="model.integrated_internal_mail_tracking_app.includes('Included')"/>
                <img src="./../../../../static/styles/mailkit/img/cross.png" v-else/>
                <br>
                {{ model.integrated_internal_mail_tracking_app }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="INBOUND COURIER PARCEL TRACING">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Outbound shipping application
              </td>
              <td>
                {{ model.shipping_application }}
                <span v-if="model.shipping_application === 'Yes Single User Included (Optional Kit available includes 30kg Scale and Shipping Label Printer)'">
                  Available at additional cost - &pound;{{ model.shipping_application_kit_sell_price }}
                </span>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="OUTBOUND SHIPPING APPLICATION">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Departmental accounting
              </td>
              <td>
                {{ model.departmental_accounting }}
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="DEPARTMENTAL ACCOUNTING">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Differential weighing
              </td>
              <td>
                <!--<img src="./../../../../static/styles/mailkit/img/tick.png" v-if="model.differential_weighting === 'Yes'"/>-->
                <img src="./../../../../static/styles/mailkit/img/cross.png" v-if="!model.differential_weighting || model.differential_weighting === 'No'"/>
                <span v-if="model.differential_weighting === 'Yes' || model.differential_weighting === 'Optional'">Available at additional cost &pound;{{ model.differential_weighing_sell_price }}</span>
              </td>
              <td>
                <a class="underline infoToggle">More information</a>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="DIFFERENTIAL WEIGHING">
                </div>
              </td>
            </tr>
            <tr style="background: #f4f4f4;">
              <td>
                Service / maintenance offering
              </td>
              <td>
                <span v-if="!service_upgrade && !new_costs.postage_recredit_costs_updated_to_total_care">
                  {{ model.service_name }}
                </span>
                <span v-if="service_upgrade == 'swapit'">
                  swapit+
                </span>
                <span v-if="service_upgrade == 'total_care' || new_costs.postage_recredit_costs_updated_to_total_care">
                  total care
                </span>
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="SERVICE / MAINTENANCE OFFERING">
                </div>
              </td>
            </tr>
            <tr style="background: #f4f4f4;">
              <td>
                First step
              </td>
              <td>
                {{ model.first_step }}
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="FIRST STEP">
                </div>
              </td>
            </tr>
            <tr style="background: #f4f4f4;">
              <td>
                Second step
              </td>
              <td>
                {{ model.second_step }}
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="SECOND STEP">
                </div>
              </td>
            </tr>
            <tr style="background: #f4f4f4;">
              <td>
                {{ service_upgrade || new_costs.postage_recredit_costs_updated_to_total_care ? 'Enhanced' : null }} Third step
              </td>
              <td>
                {{ service_upgrade || new_costs.postage_recredit_costs_updated_to_total_care ? model.enhanced_third_step : model.third_step }}
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="THIRD STEP">
                </div>
              </td>
            </tr>
            <tr style="background: #f4f4f4;">
              <td>
                {{ service_upgrade || new_costs.postage_recredit_costs_updated_to_total_care ? 'Enhanced' : null }} Targeted service level
              </td>
              <td>
                {{ service_upgrade || new_costs.postage_recredit_costs_updated_to_total_care ? model.sla_enhanced : model.sla_standard }}
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="TARGETED SERVICE LEVEL">
                </div>
              </td>
            </tr>
            <tr style="background: #f4f4f4;">
              <td>
                All parts
              </td>
              <td>
                <img src="./../../../../static/styles/mailkit/img/cross.png"
                     v-if="model.all_parts === null"/>
                <span v-else>
                   <img src="./../../../../static/styles/mailkit/img/tick.png"/> Yes
                </span>
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="ALL PARTS">
                </div>
              </td>
            </tr>
            <tr>
              <td>
                All labour
              </td>
              <td>
                <img src="./../../../../static/styles/mailkit/img/cross.png"
                     v-if="model.all_labour === null"/>
                <span v-else>
                   <img src="./../../../../static/styles/mailkit/img/tick.png"/> Yes
                </span>
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="ALL LABOUR">
                </div>
              </td>
            </tr>
            <tr style="background: #f4f4f4;">
              <td>
                Wwear & tear
              </td>
              <td>
                <img src="./../../../../static/styles/mailkit/img/cross.png"
                     v-if="model.wear_and_tear === null"/>
                <span v-else>
                   <img src="./../../../../static/styles/mailkit/img/tick.png"/> Yes - excluding consumable parts
                </span>

              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="WEAR & TEAR">
                </div>
              </td>
            </tr>
            <tr style="background: white;">
              <td>
                Royal Mail rate updates
              </td>
              <td>
                {{ model.tariff_rate_updates_included_per_annum }}
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="ROYAL MAIL RATE UPDATES">
                </div>
              </td>
            </tr>
            <tr style="background: #f4f4f4;">
              <td>
                Postage account type
              </td>
              <td>
                {{ model.manufacturer_id == 3 || model.manufacturer_id == 2 ? 'Arvanced or arrears' : 'Advanced' }}
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="nopadding">
                <div class="infoContent" style="display:none;" data-ft="POSTAGE ACCOUNT TYPE">
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </td>
  </tr>
</template>
<script>
  export default {
    props: [
      'current_costs', 'new_costs', 'model', 'quote', 'service_upgrade', 'quote_confirmation',
    ],
    created() {
      this.videoEmbed = false
      let options = [];
      options.push({
        years: this.quote.lease_option_1,
        total_investment: this.getTotalEffectiveCostValue(this.quote.lease_option_1 - 1),
        switch_and_save: this.getSwitchAndSaveValue(this.quote.lease_option_1 - 1),
        savings_over_term: this.getSavingOverTermValue(this.quote.lease_option_1 - 1),
      })
      options.push({
        years: this.quote.lease_option_2,
        total_investment: this.getTotalEffectiveCostValue(this.quote.lease_option_2 - 1),
        switch_and_save: this.getSwitchAndSaveValue(this.quote.lease_option_2 - 1),
        savings_over_term: this.getSavingOverTermValue(this.quote.lease_option_2 - 1),
      })
      if (this.quote_confirmation) {
        options.push({
          years: false,
          total_investment: this.getTotalEffectiveCostValue(),
          switch_and_save: this.getSwitchAndSaveValue(),
          savings_over_term: this.getSavingOverTermValue(),
        })
      }

      this.options = options.sort(function (a, b) {
        return b.savings_over_term - a.savings_over_term
      })

    },
    mounted() {
      let app = this
      this.getYoutubeEmbed(this.model.video_url)

      // $('.infoToggle').click(function () {
      //   var dv = $(this).parent().parent().next().find('.infoContent')
      //   dv.toggle('slow')
      //   var feature = dv.attr('data-ft')
      //   dv.html(app.getMoreInfo(feature))
      // })

    },
    data() {
      return {
        options: false,
        videoEmbed: null,
      }
    },

    methods: {
      getMoreInfo(feature) {
        var text = ''
        feature = feature.toUpperCase()

        switch (feature) {
          case 'BUSINESS MAIL ADVANCED' :
            text = 'Business Mail Advanced is a discounted mail tariff for businesses sending over 250 Letter format (DL/C5) items in any single mailing, discounts are based on items with clean addresses i.e. allowing Royal Mail to read and automatically sort/process mail without manual intervention and in doing so they pass on savings for this automation.'
            break

          case 'PRINTING CAPABILITIES':
            text = 'The vast majority of franking machines allow only for the ability to print in blue franking ink. Pitney Bowes offer a range of machines starting at automatic feeding which allow the option of mono capable or full colour capable printing, these then allow the business the option to print across the full width of the envelope in mono or colour inline with the indicia.'
            break

          case 'PROGRAMMABLE JOBS':
            text = 'The Programmable jobs function allows you to save the key jobs as presets into the franking machine. This allows for quick selection of the most popular mailing types to speed up the processing of mail. E.g. A job could be set as 1st class, large letter with all items processed to be recorded against a specific account, rather than each time having to select each of these.'
            break

          case 'INK YIELD':
            text = 'This represents the average ink yield per ink cartridge based on printing a franking indicia only.'
            break

          case 'COST PER IMPRESSION':
            text = 'The cost per impression is taken from the ink cost and published ink yield to provide a guide to the cost per each indicia printed. This excludes any logo or return address which can vary ink usage and ultimately the impressions yielded from a ink cartridge.'
            break

          case 'LOGO RETURN ADDRESS CAPACITY':
            text = 'This relates to the number of logos/graphics and return addresses that the machine has the capacity to store.'
            break

          case 'INTERFACE TYPE':
            text = 'The interface is the type of visual display, this can vary significantly between machine and manufacturer. This can be an important consideration as affects the usability, navigation of functionality and ease of use of you chosen franking solution.'
            break

          case 'MAIL FEEDER':
            text = 'Mail feeders fall into three key types for franking solutions. Hand feeding machine allow the operator to pass a single letter through the franking machine for processing, before moving on to the next letter. Automatic mail feeders allow the user to stack same size and weight items of the same class onto the feeder, it will then very quickly frank these items at the pre selected postal rate and tariff. Fully-automatic mail feeders allow the user to stack mixed size and weight items on the feeder, all the user needs to do is choose the class and the machine will automatic measure the length, width, thickness and weight on each item and frank accordingly, this prevents human errors (associated Royal Mail fines) and allows post to be processed very quickly.'
            break

          case 'LABEL DISPENSER':
            text = 'There are three types of label processing available depending on the franking machine model. Postcard style labels are provided with two label strips, one on the top and one on the bottom edge; these are processed in exactly the same way as letters for any oversized items to thick to pass through the letter feeder. Single label strips; these are loaded into a label hopped on compatible machines and allow the user to print labels quickly and easily for oversized items, this is especially useful when a large number of packets and/or parcels are being processed which do not fit through the mail feeder. The third type of label feeder is a label roll dispenser, this technology is only available on Pitney Bowes machines, the label rolls typically provide 722 indicia only prints per roll meaning infrequent requirement for refilling and an excellent solution for any mailroom producing a large number of oversize items. The labels on label rolls are cut to size so to minimise wastage, if printing an indicia only the machine will cut the label to just the size of the indicia, if printing a logo/return address the machine cuts the label longer to allow for this also.'
            break

          case 'WEB BASED REPORTING':
            text = 'Web based postage reporting provides the ability to review postage spend from any web connected PC. This is an excellent tool providing businesses with management information and a detailed understand of how your postage spend is being utilised. The reporting tools provides detail on the volumes and spend by class and allows you to down reports in pdf or excel and as graphs of a detailed table format. The same reporting information is also available on many models* with web based reporting activated to allow department account reports on items and spend processed across your chosen date ranges to support simplified cross charging processes. *check with us to confirm that your desired model allows this if this is an important function for your business*'
            break

          case 'DIMENSIONS':
            text = 'This confirms the manufacturer published dimensions of this model.'
            break

          case 'MAIL MARK COMPLIANT':
            text = 'Royal Mail introduced Mail Mark in XXXX, this moved franking machines to the ability to automatically update postal rates and transitioned machines from the old town circle franking indicia to a 2D barcode to support automation in Royal Mail processes. Mail Mark compliant machines benefit from reduced postal rates in comparison to the legacy town circle franking die options and ultimately provide greater postal savings for businesses.'
            break

          case 'INSTALLATION AND TRAINING':
            text = 'Where applicable installation and training allows for an onsite engineer to support on the setup, installation and training on the use of the new franking solution.'
            break

          case 'SCALE CAPACITY':
            text = 'There is a wide range of scale capacity options available on franking machine models, these range from 2kg-35kg depending on manufacturer and model. The larger the scale capacity the greater the functionality and flexibility of processing varied weight items for your business. However, increasing scale capacities can be a costly approach to manage irregular high weight items so it is worth considering what scale capacity is truly required. All machines have the ability to manually enter the weight of an item too heavy for the scale provided, allowing adhoc items to be weighed separately but still processed through the franking machine.'
            break

          case 'CUSTOM LOGO/RETURN ADDRESS INCLUDED WITH NEW MACHINE':
            text = 'Logo and return addresses are available on all machines, however only some provide these free of charge with the machine. Where a logo or return address isn\'t provided with the machine you have the option to add this at a cost.'
            break

          case 'CONNECTIVITY KIT OPTIONS':
            text = 'All new mailing machines require a network connection for updates, to transmit postage spend information and for postage top ups/refills. Some models offer the option of wifi connection, 3G connection (via a dongle) or PC meter connect (this utilises a PC with internet connection and some software to allow a connection.'
            break

          case 'INBOUND COURIER PARCEL TRACING':
            text = ' This technology is only available from Pitney Bowes and provides the ability to add a barcode scanner to the franking machine. This then allows the users to scan the barcode on items received, input the intended recipient, send an email notification to the recipient confirming an item has been received for them before the team print a delivery manifest on a connected printed (not supplied) and take to the recipient to sign on delivery. Future upgrade options are available to allow delivery and signature capture via WiFi or 3g connected PDAs.'
            break

          case 'OUTBOUND SHIPPING APPLICATION':
            text = 'This technology allows users to rate shop for recorded, special delivery 1pms and parcel/packets for shipping. The kit provides the license, a shipping label printer and 30kg scale for PC connection. A user can then save regular recipients they send to whilst also entering the email of the sender and recipient to provide tracking information automatically on posting.'
            break

          case 'DEPARTMENTAL ACCOUNTING':
            text = 'Departmental accounting allows your business to name accounts and allocate items/spend to the relevant accounts. This then allows future reporting to simplify the process of cross billing.'
            break

          case 'DIFFERENTIAL WEIGHING':
            text = 'The differential weighing feature is a great feature for any business regularly sending a large number of packets/parcels. The operator can stack the items collectively on the scale, choose the appropriate class and under differential mode as an item is removed a label for the item can be printed and applied to that item, this process can then be repeated for all items on the scale speeding up the process of shipping.'
            break

          case 'SERVICE / MAINTENANCE OFFERING':
            text = 'Information being prepared...'
            break

          case 'FIRST STEP':
            text = 'Information being prepared...'
            break

          case 'SECOND STEP':
            text = 'Information being prepared...'
            break

          case 'THIRD STEP':
            text = 'Information being prepared...'
            break

          case 'TARGETED SERVICE LEVEL':
            text = 'Information being prepared...'
            break

          case 'ALL PARTS':
            text = 'Information being prepared...'
            break

          case 'ALL LABOUR':
            text = 'Information being prepared...'
            break

          case 'WEAR & TEAR':
            text = 'Information being prepared...'
            break

          case 'ROYAL MAIL RATE UPDATES':
            text = 'Information being prepared...'
            break

          case 'POSTAGE ACCOUNT TYPE':
            text = 'Information being prepared...'
            break

        }
        return text
      },
      getYoutubeEmbed(url) {
        let youTubeUrl = url
        let youTubeId
        let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
        let match = youTubeUrl.match(regExp)
        if (match && match[2].length == 11) {
          youTubeId = match[2]
        } else {
          youTubeId = false
        }
        let embed = false
        if (youTubeId) {
          embed = '<iframe width="100%" height="auto" src="//www.youtube.com/embed/' + youTubeId + '" frameborder="0" allowfullscreen></iframe>'
        }
        this.videoEmbed = embed
      },
      getSwitchAndSaveValue(years = -1) {
        let value;
        if (years === -1) {
          value = this.new_costs.switch_and_save.purchase;
        } else {
          value = this.new_costs.switch_and_save.lease[years];
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : '-';
      },
      getTotalEffectiveCostValue(years = -1) {
        let value;
        if (years === -1) {
          value = this.new_costs.total_effective_cost.purchase;
        } else {
          value = this.new_costs.total_effective_cost.lease[years];
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : '-';
      },
      getSavingOverTermValue(years = -1) {
        let value;
        if (years === -1) {
          value = this.new_costs.saving_over_term.purchase;
        } else {
          value = this.new_costs.effective_annual_saving.lease[years];
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : '-';

      },
      manufacturerImage(manufacturer_id = false) {
        if (!manufacturer_id)
          return 'http://placehold.it/195x195'

        return '/static/styles/mailkit/img/logos/manu' + (manufacturer_id - 1) + '.png'
      },
      makeNumberWithPound(number) {
        if (number < 0) {
          return '-&pound;' + _n(Math.abs(number))
        }
        return '&pound;' + _n(number)
      },
      progressWithOrder(investment_option) {
        if (investment_option === false) investment_option = 0
        this.$emit('progress-with-order', investment_option)
      }
    }
  }
</script>
<style scoped>
  .optionsPanel__image {
    height: 200px !important;
  }
  .manufacturer_image {
    width: auto !important;
    height:200px;
  }

  .height-250 {
    height: 180px !important;
  }

  .option-btn {
    color: white !important;
    cursor: pointer;
    margin-top: 5px;
    background: #0a70e3 !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/ProposalTemplate/Partials/SummaryMoreInfo.vue